import { Component, Inject } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { ButtonModule } from "primeng/button";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { PanelModule } from "primeng/panel";
import { ToggleButtonModule } from "primeng/togglebutton";
import { DialogModule } from 'primeng/dialog';
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { ScrollPanel } from "primeng/scrollpanel";


@Component({
  selector: 'app-alert-dialog-prime-component',
  standalone: true,
  imports: [
    CommonModule,
    ConfirmDialogModule,
    ButtonModule,
    PanelModule,
    ToggleButtonModule,
    DialogModule,
    FormsModule,
    DialogModule,
    ScrollPanel,
  ],
  templateUrl: './alert-dialog-prime-component.component.html',
  styleUrls: ['./alert-dialog-prime-component.component.css'],
  providers: [DialogService, ConfirmationService]
})
export class AlertDialogPrimeComponentComponent {
  information: boolean = false;
  viewDetail: boolean = false;
  data: any;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) { this.data = config.data; }

  ngOnInit(): void {
    this.information = this.config.data.detalle == '' ? false : true;
  }

  view() {
    this.viewDetail = !this.viewDetail;
  }

  onAccept() {
    this.ref.close(true);
  }

  onReject() {
    this.ref.close(false);
  }

  onClose() {
    this.ref.close();
  }

  getTextoOpcion1(): string {
    return this.config.data.textoBtn?.textoBtnOpcion1 || 'Aceptar';
  }

  getTextoOpcion2(): string {
    return this.config.data.textoBtn?.textoBtnOpcion2 || 'Cancelar';
  }
}
